import { BaseCarData } from '@/types/Car.types';
import { ProductListDataRow } from '@/types/CataloguePage.types';

type CarData = BaseCarData | ProductListDataRow;

const convertProductsToGa = (products: CarData[]) =>
  products.map((product, idx) => {
    // Handle both BaseCarData (with makeModel array) and ProductListDataRow (with separate make/model)
    const make = 'makeModel' in product ? product.makeModel?.[0] || '' : product.make || '';
    const model = 'makeModel' in product ? product.makeModel?.[1] || '' : product.model || '';
    const bodyType = 'bodyType' in product ? product.bodyType : product.body || '';
    const price = typeof product.price === 'string' ? product.price : product.price?.toString() || '';

    // Use title for ProductListDataRow, model for BaseCarData
    const itemName = 'title' in product ? product.title : model;

    return {
      index: idx,
      item_id: product.sku,
      item_name: itemName,
      currency: 'AUD',
      item_brand: make,
      item_category: model,
      item_category2: bodyType,
      item_category3: product.transmission,
      item_category4: product.ancapRating,
      item_category5: product.buildYear,
      item_variant: product.colour,
      price: price,
    };
  });

export const formatViewItemListEvent = (
  page: number,
  pages: number,
  currentSlug: string,
  sort: string,
  data: CarData[],
) => {
  return data.length > 0
    ? {
        event: `view_item_list`,
        item_list_id: null,
        item_list_name: currentSlug,
        page,
        pages,
        sort,
        url: window.location.href,
        ecommerce: {
          items: data.length !== 0 ? convertProductsToGa(data) : undefined,
        },
        item_id_list: data.length !== 0 ? data.map((item) => item.sku) : undefined,
      }
    : null;
};
